module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-6c089a55.png";